// const mainContent = document.querySelector("main");
const shopifySectionHeader = document.getElementById("shopify-section-header");
const subHeaderSpItems = document.getElementById("subHeaderSpItems");
const spSubHeader = document.getElementById("subHeaderSp");
const ham = document.getElementById("headerSpHamburger");
const hamburgerIcon = document.getElementById("hamburgerIcon");
const hamburgerIconClose = document.getElementById("hamburgerIconClose");

const subHeaderSpItemsMinHeight =
  window.innerHeight - spSubHeader.clientHeight + 0.2;

subHeaderSpItems.style.minHeight = `${subHeaderSpItemsMinHeight}px`;

let modalFlag = false;

ham.addEventListener("click", () => {
  if (modalFlag == false) {
    hamburgerIcon.style.display = "none";
    hamburgerIconClose.style.display = "block";
    spSubHeader.classList.remove("modal-close");
    spSubHeader.classList.add("modal-open");
    modalFlag = true;
  } else {
    hamburgerIconClose.style.display = "none";
    hamburgerIcon.style.display = "block";
    spSubHeader.classList.remove("modal-open");
    spSubHeader.classList.add("modal-close");
    modalFlag = false;
  }
});

const searchInput = document.getElementById("Search-In-Modal");
const productSearchButton = document.getElementById("productSearchButton");

productSearchButton.addEventListener("click", () => {
  if (searchInput.value == "") {
    window.location.href = "/collections/all";
  }
});

const searchInputSp = document.getElementById("Search-In-Modal-1");
const productSearchButtonSp = document.getElementById("productSearchButtonSp");

productSearchButtonSp.addEventListener("click", () => {
  if (searchInputSp.value == "") {
    window.location.href = "/collections/all";
  }
});

const searchInTemplate = document.getElementById("Search-In-Template");
const templateSearchButton = document.getElementById("templateSearchButton");

templateSearchButton.addEventListener("click", () => {
  if (searchInTemplate.value == "") {
    window.location.href = "/collections/all";
  }
});
